import React from 'react';
import { LocaleConfigContext } from '../../../contexts/locale-config/locale-config';
import { getDetectedDevice } from '../../../utils/device-detection';
import { Header as HeaderDesktop } from './header-desktop-old/Header';
import { Header as HeaderMobile } from './header-mobile-old/Header';
import { IFrontendHeader, IFrontendHeaderContent } from '../../../../../interfaces';
import { IHeaderEnhancedProps } from './interface';

interface IHeaderProps {
    desktopHeaderData?: IFrontendHeader;
    mobileHeaderData?: IFrontendHeader;
    headerContent?: IFrontendHeaderContent;
    hideMenu?: boolean;
    hideFavorites?: boolean;
    contactTargetBlank?: boolean;
}

const Header = (props: IHeaderProps) => {
    const localeConfig = React.useContext(LocaleConfigContext);
    const countryCode = localeConfig.code === 'au' ? 'cruiseaway' : localeConfig.code;

    const headerProps = {
        appConfig: {
            countryCode,
        },
        config: {
            contentEndpoint: `https://www.${localeConfig.url}/`,
        },
        brandConfig: {
            contactPagePath: localeConfig.slugs.contact,
        },
        phoneNumber: localeConfig.phoneNumber,
        items: {
            headerContent: props.headerContent || {},
        },
    } as IHeaderEnhancedProps;

    if (!props.desktopHeaderData || !props.mobileHeaderData) {
        return null;
    }

    const device = getDetectedDevice();
    const isMobileDevice = ['mobile', 'tablet'].indexOf(device) >= 0;
    const headerData = isMobileDevice ? props.mobileHeaderData : props.desktopHeaderData;

    const favoritesSlug = headerData.subNavigation.length
        ? headerData.subNavigation.find((o: any) => o.identifier === 'icHeart')?.targetUrl
        : '';

    headerProps.items = {
        ...headerData,
        headerContent: props.headerContent || {},
    };

    headerProps.favoritesUrl = `https://www.${localeConfig.url}${favoritesSlug}`;
    headerProps.favoriteCount = 0;

    const header = isMobileDevice ? (
        <HeaderMobile
            {...headerProps}
            device={device}
            hideMenu={props.hideMenu}
            hideFavorites={props.hideFavorites}
            contactTargetBlank={props.contactTargetBlank}
        />
    ) : (
        <HeaderDesktop
            {...headerProps}
            hideMenu={props.hideMenu}
            hideFavorites={props.hideFavorites}
            contactTargetBlank={props.contactTargetBlank}
        />
    );

    return header;
};

export default Header;
